module.exports = __webpack_public_path__ + "static/media/tick_inactive118483aa.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/ui/images/tick_inactive.svg
// module id = 1457
// module chunks = 0